import { render, staticRenderFns } from "./dropdown-multiselect.vue?vue&type=template&id=2237b276&"
import script from "./dropdown-multiselect.vue?vue&type=script&lang=js&"
export * from "./dropdown-multiselect.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-multiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports